var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"mousemove":_vm.cursorListener}},[_c('div',{staticClass:"router-view"},[_c('div',{staticClass:"content"},[_c('router-view',{key:_vm.$route.path})],1)]),(!_vm.mobileDevice)?_c('cursor-painter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }